import { defineComponent, getCurrentInstance } from 'vue';
export default defineComponent({
    name: 'MemberDetail',
    components: {
        MemberInfo: () => import('./components/MemberInfo.vue'),
        LoginHistory: () => import('./components/LoginHistory.vue')
    },
    setup(props) {
        const root = getCurrentInstance().proxy;
        const { companyId, memberSeq } = root.$route.params;
        return {
            companyId, memberSeq
        };
    }
});
